import { Image, Text } from 'components/index'
import { MojitoSwap } from 'constants/footerList'
import React from 'react'
import { useTranslation, Trans } from 'react-i18next'
import styled from 'styled-components'
import { BetweenBox, CenterBox, ColumnCenterBox, RowCenterBox } from '../index'
import { useResponsive } from '../../hooks/useResponse'
import { useMJTAPR } from 'state/application/hooks'

export const Button = styled(CenterBox)`
  background: linear-gradient(91.72deg, #14d89d 1.03%, #0ac4dd 102.03%);
  border-radius: 22px;
  font-family: 'SF Pro Display Bold';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  /* identical to box height */
  width: 130px;
  height: 36px;
  text-align: center;
  color: #ffffff;
  margin-right: 24px;
  cursor: pointer;
`

const AppFooterWrap = styled.div`
  padding-top: 75px;
  padding-bottom: 50px;
  width: 100%;
  position: relative;
  z-index: 99;
  display: flex;
  flex-flow: column wrap;
  justify-content: space-between;
  align-items: center;
  height: auto;
  background: #fff;
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    text-align: center;
  }
`
const AppFooterContentWrap = styled.div`
  width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  @media (max-width: 768px) {
    width: 100%;
    padding-top: 0px;
  }
`

const MediaIcon = styled.div`
  width: 42px;
  height: 42px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: scale(1.1);
  }
`

const Slogan = styled.div`
  font-family: 'SF Pro Rounded';
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  color: #01142a;
  white-space: nowrap;
  height: 34px;
`

const Desc = styled.div`
  font-family: 'SF Pro Rounded';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #666666;
  margin: 18px 0 25px 0;
`

const StakeButton = styled.div`
  height: 40px;
  background: linear-gradient(91.72deg, #14d89d 1.03%, #0ac4dd 102.03%);
  border-radius: 30px;
  width: 140px;
  height: 40px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'SF Pro Display';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  color: #ffffff;
  @media (max-width: 768px) {
    align-items: center;
    margin: 0 auto;
  }
`

const Link = styled.a`
  text-decoration: none;
  &:hover {
    color: #fff;
  }
`

const DefaultText = styled(Text)`
  color: #666;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
`

const AprText = styled.b`
  color: #14d89d;
  font-weight: 700;
`

const Footer: React.FunctionComponent = () => {
  const { t } = useTranslation()
  const { isMobile } = useResponsive()
  const [activeList, setActiveList] = React.useState<boolean[]>([false, false, false, false])

  const mjtAPY = useMJTAPR()

  return (
    <AppFooterWrap>
      <AppFooterContentWrap>
        <BetweenBox
          style={{
            flexFlow: isMobile ? 'column nowrap' : 'row nowrap',
            alignItems: 'flex-start',
            justifyContent: isMobile ? 'space-between' : 'flex-start',
          }}
        >
          <ColumnCenterBox
            align={isMobile ? 'center' : 'flex-start'}
            style={{
              width: isMobile ? '100%' : '320px',
              order: isMobile ? 1 : 0,
              marginTop: isMobile ? '40px' : '0px',
            }}
          >
            <Image src="/images/mojito-games-logo-with-text.png" width={108} height={36} alt="mojito-game-logo" />
            <DefaultText marginTop="14px" color="#666666" style={{ whiteSpace: 'nowrap' }}>
              {t('GAME_9')}
            </DefaultText>
            <BetweenBox style={{ width: '100%', marginTop: '20px' }}>
              {MojitoSwap.CONTACT_LIST.map((media, index) => {
                return (
                  <MediaIcon
                    key={media.route}
                    onClick={() => {
                      window.open(media.route)
                    }}
                    onMouseEnter={() => {
                      setActiveList(() => {
                        const arr = new Array(MojitoSwap.CONTACT_LIST.length).fill(false)
                        arr.splice(index, 1, true)
                        return arr
                      })
                    }}
                    onMouseLeave={() => {
                      setActiveList(() => {
                        return new Array(MojitoSwap.CONTACT_LIST.length).fill(false)
                      })
                    }}
                  >
                    <Image
                      width="42px"
                      height="42px"
                      alt="media-icon"
                      src={activeList[index] ? media.hoverIcon : media.icon}
                    />
                  </MediaIcon>
                )
              })}
            </BetweenBox>
            <DefaultText marginTop="16px" color="#666666" style={{ whiteSpace: 'nowrap' }}>
              &copy; {new Date().getFullYear()} {t('GAME_13')}
            </DefaultText>
          </ColumnCenterBox>
          <RowCenterBox
            style={{
              flexFlow: isMobile ? 'column nowrap' : 'row nowrap',
              order: isMobile ? 0 : 1,
              justifyContent: 'space-between',
              marginLeft: isMobile ? '0px' : '290px',
              alignItems: isMobile ? 'center' : 'flex-start',
              flex: 1,
              height: '100%',
              marginTop: isMobile ? '0px' : '-20px',
            }}
          >
            <Image
              width="209px"
              height="200px"
              src={require('../../assets/images/lottery/empty.png').default}
              alt="search-image"
            />
            <ColumnCenterBox align="flex-start" style={{ marginLeft: isMobile ? '0px' : '30px' }}>
              <Slogan style={{ marginTop: '30px' }}>{t('GAME_10')}</Slogan>
              <Desc>
                <Trans
                  i18nKey="GAME_12"
                  values={{
                    apr: mjtAPY.loaded === true && mjtAPY.apy !== 0 ? `${mjtAPY.apy}% ` : '- ',
                  }}
                  components={{ number: <AprText /> }}
                />
              </Desc>
              <StakeButton>
                <Link href="https://app.mojitoswap.finance/farm" target="_blank">
                  {t('GAME_11')}
                </Link>
              </StakeButton>
            </ColumnCenterBox>
          </RowCenterBox>
        </BetweenBox>
      </AppFooterContentWrap>
    </AppFooterWrap>
  )
}

export default Footer
